import React from "react";
import BreadcrumbTwo from "../components/BreadcrumbTwo";
import OrderConfirm from "../components/OrderConfirm";

const OrderConfirmPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Order Confirmed" />
      <OrderConfirm />
    </>
  );
};

export default OrderConfirmPage;